import React, { forwardRef } from 'react'
import NavListItem from '../NavListItem/NavListItem'
import ArrowLeftIcon from '../../../../images/icons/arrow-left.svg'
import ButtonVariantEnum from '../../../../enums/ButtonVariant'
import Button from '../../../Button/Button'
import { useDrawerControls } from '../../Drawer.hook'
import { StyledNavList, StyledNavListItemContainer, StyledNavTitle, StyledNavTitleContainer } from './NavList.styled'


export const NavList = forwardRef(({items = [], isSubNav = false, title = null, onClickNext, companyNavigation}, ref)=> {

  const { onClickPrev } = useDrawerControls()
  const color = items.length && companyNavigation?.findIndex(el => el.id === items[items.length-1].id) !== -1 ? 'white' : 'black'

  return (
    <StyledNavList isSubNav={isSubNav} key={title ? `${title}Nav` : 'mainNav'} ref={ref} isColored={color}>
      <StyledNavListItemContainer>
      {title &&  (
        <StyledNavTitleContainer>
          <Button
            variant={ButtonVariantEnum.tertiary}
            title={`Go to previous list`}
            iconOnly
            onClick={() => onClickPrev(ref)}
          >
            <ArrowLeftIcon />
          </Button>
          <StyledNavTitle as='h3'>{title}</StyledNavTitle>
        </StyledNavTitleContainer>
        )}
        {items.map((item, index) => (
          <NavListItem
            key={item.id + index}
            item={item}
            onClickNext={onClickNext}
            companyNavigation={companyNavigation}/>
        ))}

      </StyledNavListItemContainer>
    </StyledNavList>
  )
})

